import { Box, Grid, Heading } from "@sidelinesports/fan-design-system";
import { useCallback } from "react";
import { ScoringEventItem } from "../LiveFeed/components/ScoringEventItem.tsx";
import { useLiveFeedEntries } from "../LiveFeed/hooks/use-live-feed-entries.ts";

export const LatestEvent = () => {
  const latestScoringEvent = useLatestScoringEvent();

  const handleClick = useCallback(() => {
    const element = document.getElementById("live-feed-trigger-button");

    element?.click();
  }, []);

  if (!latestScoringEvent) {
    return null;
  }

  return (
    <Box
      bg="rgba(255, 255, 255, 0.1)"
      borderRadius="0.5rem"
      p={16}
      onClick={handleClick}
      style={{ cursor: "pointer" }}
    >
      <Grid gap={16}>
        <Heading level={5}>Latest</Heading>
        <ScoringEventItem scoringEvent={latestScoringEvent} />
      </Grid>
    </Box>
  );
};

function useLatestScoringEvent() {
  const liveFeed = useLiveFeedEntries();

  if (liveFeed.entries.length === 0) {
    return null;
  }

  return (
    liveFeed.entries.filter((entry) => entry.kind === "SCORING_EVENT").at(0) ??
    null
  );
}
